module.exports = __webpack_public_path__ + "img/newchris-98.01c2fb1d.jpg";